import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  countyList,
  zipcodeCountyEndpoint,
} from './add-or-edit-modal.constants';
import { CountyDetails } from './add-row-modal.model';

@Injectable({
  providedIn: 'root',
})
export class AddOrEditModalService {
  constructor(public http: HttpClient) {}

  getCounty(zipcode: number): Observable<CountyDetails> {
    return this.http.get<CountyDetails>(
      `${zipcodeCountyEndpoint}${zipcode}/${countyList}`,
    );
  }
}
